<template>
  <span>
    <crud-layout-search
      ref="CrudLayoutSearchMain"
      :pageDetail="pageDetail"
      :page-table="pageTable"
      :page="page"
      :params="params"
      :interface="nmInterface"
      clean-layout
      class="contract-client"
      maximized
    />
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'
import ContractDetail from '../contract/ContractDetail'
import ContractUpdate from '../contract/ContractUpdate'
import ContractPageTable from '../contract/ContractPageTable'

const { pageDetail, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [pageDetail],
  name: 'ContractClient',
  components: { CrudLayoutSearch, ContractDetail, ContractUpdate, ContractPageTable },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ContractClient extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return ContractUpdate
  }

  get pageDetail () {
    return ContractDetail
  }

  get pageTable () {
    return ContractPageTable
  }
}
export default ContractClient
</script>

<style lang="stylus" scoped>
@import '~quasar-variables';

.contract-client {
  .buttons-top-crud {
    padding: 10px 14px;
  }

  .q-table th, .q-table td {
    padding: 0px 10px !important;
  }

}

@media only screen and (max-height: 750px) {
  .contact-client {
    .table-crud .jt-datatable {
      padding-bottom: 0px;
    }
  }
}
</style>
